/**
 * Trainova AI — Multilingual & Internationalization Types
 */

export type SupportedLanguageCode =
  | 'en'
  | 'en-GB'
  | 'es'
  | 'fr'
  | 'de'
  | 'hi'
  | 'ta'
  | 'te'
  | 'kn'
  | 'mr'
  | 'bn'
  | 'ar'
  | 'pt'
  | 'ja'
  | 'zh';

export interface LanguageMeta {
  code: SupportedLanguageCode;
  name: string;
  nativeName: string;
  flag: string;
  isRtl?: boolean;
}

export const SYSTEM_LANGUAGES: LanguageMeta[] = [
  { code: 'en', name: 'English (US)', nativeName: 'English (US)', flag: '🇺🇸' },
  { code: 'en-GB', name: 'English (UK)', nativeName: 'English (UK)', flag: '🇬🇧' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', flag: '🇩🇪' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी', flag: '🇮🇳' },
  { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்', flag: '🇮🇳' },
  { code: 'te', name: 'Telugu', nativeName: 'తెలుగు', flag: '🇮🇳' },
  { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ', flag: '🇮🇳' },
  { code: 'mr', name: 'Marathi', nativeName: 'मराठी', flag: '🇮🇳' },
  { code: 'bn', name: 'Bengali', nativeName: 'বাংলা', flag: '🇮🇳' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦', isRtl: true },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português', flag: '🇧🇷' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語', flag: '🇯🇵' },
  { code: 'zh', name: 'Chinese (Simplified)', nativeName: '简体中文', flag: '🇨🇳' },
];

export interface LanguageContextValue {
  currentLanguage: string;
  setLanguage: (lang: string) => Promise<void>;
  supportedLanguages: string[];
  availableLanguages: LanguageMeta[];
  tenantDefaultLanguage: string;
  fallbackLanguage: string;
  allowUserLanguageSelection: boolean;
  isRTL: boolean;
  isLoading: boolean;
  t: (key: string, params?: Record<string, string | number>, defaultText?: string) => string;
  translateDynamic: (text: string, options?: { context?: string }) => Promise<string>;
}
